
















import { Vue, Component, Prop } from "vue-property-decorator";
import { IEventable } from '@/loader';

@Component
export default class EventableEdit extends Vue {
	@Prop({ type: Object, default: null })
	public item!: IEventable;

	@Prop({ type: Boolean, default: false })
	public hideDescription!: boolean;

	@Prop({ type: Boolean, default: false })
	public hideDate!: boolean;
}
